import moment from "moment";
import { api } from "../../Lib/constants";
import { getAuthHeader } from "../../Lib/utils";
import {
  ADDSPEND,
  ADDSPEND_FAILED,
  ADDSPEND_SUCCESS,
  DELETESPEND,
  DELETESPEND_FAILED,
  DELETESPEND_SUCCESS,
  SPEND,
  SPEND_FAILED,
  SPEND_SUCCESS,
  SPENDSLIST,
  SPENDSLIST_FAILED,
  SPENDSLIST_SUCCESS,
  SPENDTRANSACTIONLIST,
  SPENDTRANSACTIONLIST_FAILED,
  SPENDTRANSACTIONLIST_SUCCESS,
  UPDATESPEND,
  UPDATESPEND_FAILED,
  UPDATESPEND_SUCCESS,
} from "./actionType";

export const getSpendList = () => async (dispatch) => {
  dispatch({
    type: SPENDSLIST,
  });
  try {
    let response = await api(`spends/list`, "get", {}, getAuthHeader());
    console.log("SPENDS data", response);
    dispatch({
      type: SPENDSLIST_SUCCESS,
      payload: response?.data,
    });
    return response;
  } catch (error) {
    console.log("while fetching spendlist error ====>", error);
    return dispatch({
      type: SPENDSLIST_FAILED,
      payload: error?.message,
    });
  }
};
export const getSpendTransactionList = (id , params) => async (dispatch) => {
  dispatch({
    type: SPENDTRANSACTIONLIST,
  });
  try {
    let response = await api(
      `spends/transactions/${id}${params}`,
      "get",
      {},
      getAuthHeader()
    );
    dispatch({
      type: SPENDTRANSACTIONLIST_SUCCESS,
      payload: response?.data,
    });
    return response;
  } catch (error) {
    console.log("while fetching spend transactions list error ====>", error);
    return dispatch({
      type: SPENDTRANSACTIONLIST_FAILED,
      payload: error?.message,
    });
  }
};
export const getSpendById = (id) => async (dispatch) => {
  dispatch({
    type: SPEND,
  });
  try {
    let response = await api(`spends/${id}`, "get", {}, getAuthHeader());
    dispatch({
      type: SPEND_SUCCESS,
      payload: response?.data,
    });
    return response;
  } catch (error) {
    console.log("while fetching spend details, error ====>", error);
    return dispatch({
      type: SPEND_FAILED,
      payload: error?.message,
    });
  }
};
export const addNewSpend = (data) => async (dispatch) => {
  dispatch({
    type: ADDSPEND,
  });
  try {
    let response = await api(`spends/add`, "post", data, getAuthHeader());
    dispatch({
      type: ADDSPEND_SUCCESS,
      payload: response?.data,
    });
    return response;
  } catch (error) {
    console.log("while adding new spend, error ====>", error);
    return dispatch({
      type: ADDSPEND_FAILED,
      payload: error?.message,
    });
  }
};
export const updateExistingSpend = (id, data) => async (dispatch) => {
  dispatch({
    type: UPDATESPEND,
  });
  try {
    let response = await api(
      `spends/update/${id}`,
      "put",
      data,
      getAuthHeader()
    );
    dispatch({
      type: UPDATESPEND_SUCCESS,
      payload: response?.data,
    });
    return response;
  } catch (error) {
    console.log("while updating existing spend, error ====>", error);
    return dispatch({
      type: UPDATESPEND_FAILED,
      payload: error?.message,
    });
  }
};
export const deleteSpend = (id) => async (dispatch) => {
  dispatch({
    type: DELETESPEND,
  });
  try {
    let response = await api(
      `spends/delete/${id}`,
      "put",
      { deleted_at: moment() },
      getAuthHeader()
    );
    dispatch({
      type: DELETESPEND_SUCCESS,
    });
    return response;
  } catch (error) {
    console.log("while deleting existing spend, error ====>", error);
    return dispatch({
      type: DELETESPEND_FAILED,
      payload: error?.message,
    });
  }
};
